import ConfirmationDlg from "../ConfirmationDlg";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { dashboard } from "../../api";
import { format } from "date-fns";

function ModalAnnauncement({ openModal, setOpenModal, onSuccess, onCancel }) {
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [quantity, setQuantity] = React.useState(1);
  const [relocateFrom, setRelocateFrom] = React.useState("");
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
    onCancel();
  };
  const submitHandler = async () => {
    if (relocateFrom === "" || quantity === "") {
      toast.error("Please input the field");
      return;
    }
    const payload = {
      date: format(new Date(), "dd/MM/yyyy"),
      sensor_qty: quantity,
      machine: relocateFrom,
      reason: reason,
    };
    const send = await dashboard.requestRelocate(payload);

    setOpenModal(false);
    setTextValue("");
    setOpen(false);
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  const handleChangeValue = (e) => {
    setQuantity(e.target.value);
  };
  return (
    <ConfirmationDlg
      open={open}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={submitHandler}
      onClose={handleClose}
    >
      <h4>Request Relocate Sensor</h4>
      <div className="my-2">
        <div>
          <div>
            <label>How many sensors to relocate:</label>
          </div>
          <input
            style={{
              width: "100%",
              padding: "5px",
            }}
            type="number"
            placeholder="Quantity"
            value={quantity}
            onChange={handleChangeValue}
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <div>
            <label>Relocate from what machine:</label>
          </div>
          <input
            style={{
              width: "100%",
              padding: "5px",
            }}
            type="text"
            placeholder="Machine Name"
            value={relocateFrom}
            onChange={(e) => setRelocateFrom(e.target.value)}
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <div>
            <label>Description:</label>
          </div>
          <input
            style={{
              width: "100%",
              padding: "5px",
            }}
            type="text"
            placeholder="Write Relocation Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalAnnauncement;
